import Vue from 'vue';
import optionalPropertyPlugin from './optionalProperty.filter';

Vue.use(optionalPropertyPlugin);
